// BasicCensusFlowLayout
export const PAGE_LOADER_TEST_ID = 'page-loader-test-id';

// CensusUpload

export const FILE_UPLOAD_TEST_ID = 'file-upload-test-id';
export const DIFFERENT_FILE_TYPES_MSG_TEST_ID = 'different-file-types-msg-test-id';
export const CENSUS_ERRORS_MSG_TEST_ID = 'census-errors-msg-test-id';
export const CHECK_DATA_BTN_TEST_ID = 'check-data-btn-test-id';
export const CENSUS_UPLOAD_LOADER_TEST_ID = 'census-upload-loader-test-id';
export const DOWNLOAD_PREVIOUS_FILES_BTN_TEST_ID = 'download-previous-btn-test-id';

// CensusTemplateSection

export const DOWNLOAD_TEMPLATE_BTN_TEST_ID = 'download-template-btn-test-id';

// ExistingInvalidCensusSection

export const INVALID_CENSUS_SECTION_TEST_ID = 'invalid-census-section-test-id';
export const REVIEW_ERRORS_BTN_TEST_ID = 'review-errors-btn-test-id';

// ExistingValidCensusSection

export const VALID_CENSUS_SECTION_TEST_ID = 'valid-census-section-test-id';
export const COMPLETE_CENSUS_BTN_TEST_ID = 'complete-census-btn-test-id';

// HelpButton

export const HELP_BTN_TEST_ID = 'help-btn-test-id';
